/**
 * `ANIMALS_MARKERS` (map data) and the item catalog disagree on ids for 3 of the 8 wild animals.
 *
 * The map calls them `rabbit`, `mink` and `otter`; the catalog calls the same animals `bunny`,
 * `ferret` and `sea-otter`. Neither side is wrong enough to rename — the map ids are baked into
 * marker coordinates, the catalog ids are live URLs — so the mismatch is bridged here.
 *
 * It has to be shared rather than local to one page: `AnimalDetailPage` had a private copy, and
 * the homepage did not, so its cards linked to `/animals/rabbit` (a real 404) and rendered the
 * raw id as the animal's name — `LocalizedItemName` falls back to the id for anything the catalog
 * does not model, which is exactly what that fallback looks like.
 */
const CATALOG_BY_MARKER: Record<string, string> = {
  rabbit: "bunny",
  mink: "ferret",
  otter: "sea-otter",
};

const MARKER_BY_CATALOG: Record<string, string> = Object.fromEntries(
  Object.entries(CATALOG_BY_MARKER).map(([marker, catalog]) => [catalog, marker]),
);

/** Map-marker id -> the id the item catalog uses. Identity for the other five animals. */
export function animalCatalogId(markerId: string): string {
  return CATALOG_BY_MARKER[markerId] ?? markerId;
}

/** Catalog id -> the id the map data uses. Identity for the other five animals. */
export function animalMarkerId(catalogId: string): string {
  return MARKER_BY_CATALOG[catalogId] ?? catalogId;
}
